import axios from 'axios';
import haversine from 'haversine-distance';
// import json from '../../../_patterns/01-components/Find-A-Hopsital/fah-mock-response.json';

var VCA = VCA || {};
// var mockData = json;

VCA.FindAHospital = (function ($) {
    var ui = {};
    var _urlParams = {};

    function bindEvents() {
        ui.$filterPill.on('click', selectFilter);
        ui.$searchBtn.on('click', selectSearch);
        ui.$searchValue.on('keypress', function (e) {
            if (e.which == 12) {
                selectSearch();
            }
        });
        ui.$searchRadiusUL.on('click', 'li', selectSearch);
    }

    function cacheUI() {
        ui.$filterPill = $('.filter-pills__pill');
        ui.$searchBtn = $('.find-search-btn');
        ui.$mapContainer = $("#FindAHospitalMap");
        ui.$loadingSpinner = $('.search-results-container__loading');
        ui.$resultsContainer = $('.search-results-container__list');
        ui.$errorMsgContainer = $('.search-results-container__error-msg-container');
        ui.$errorMessage = $('.search-results-container__error-msg');
        ui.$searchValue = $('#SearchInput');
        ui.$searchRadius = $('#SearchRadius');
        ui.$searchRadiusUL = $('#SearchRadiusUL');
        ui.$defaultRadius = $('#defaultRadius').val();
        ui.$defaultLatitude = $("#defaultLatitude").val();
        ui.$defaultLongitude = $("#defaultLongitude").val();
        ui.$defaultFilter = $('.filter-pills__pill.active').attr('data-filter-value');
        ui.$countryId = $('#countryId').val();
        ui.$dataId = $('#dataId').val();
        ui.isCanada = $('[data-iscanada]').attr('data-iscanada');
        ui.$map;
        ui.$geocoder;
        ui.$currentLat;
        ui.$currentLng;
        ui.$bounds;
        ui.$prevSearchValue;
        ui.$markers = [];
        ui.$selectedFiltersArr = [];
    }

    function calcMinMaxLatLng(bounds) {
        var obj = {
            minLat: bounds.getNorthEast().lat(),
            maxLat: bounds.getSouthWest().lat(),
            minLng: bounds.getNorthEast().lng(),
            maxLng: bounds.getSouthWest().lng()
        }
        return obj;
    }

    function closeModal(e) {
        e.stopPropagation();
        var parentEl = e.target.closest('.hours-modal');
        $(parentEl).css('display', 'none');
    }

    function createCard(hospitals) {
        var bounds = new google.maps.LatLngBounds();

        for (var a = 0; a < hospitals.length; a++) {
            var hospitalTypesTags = hospitals[a].HospitalTypes;
            var hoursObj = hospitals[a].HoursForFAH;
            var parentContainer = $(document.createElement('li')).addClass('search-item');
            var leftContainer = $(document.createElement('div')).addClass('search-item__left').css('background-image', `url(${hospitals[a].HospitalImageUrl})`);
            var rightContainer = $(document.createElement('div')).addClass('search-item__right');
            var typeTagsWrapper = $(document.createElement('ul')).addClass('search-item__type-tags');
            var descContainer = $(document.createElement('div')).addClass('search-item__desc-container');
            var ctaContainer = $(document.createElement('div')).addClass('search-item__cta-container');
            var modalContainer = $(document.createElement('div')).addClass('hours-modal').attr({
                'id': `HoursModal-${a}`,
                'tab-index': '-1',
                'role': 'dialog'
            });
            var modalContentWrapper = $(document.createElement('div')).addClass('hours-modal__content modal-content').attr('role', 'document');
            var modalHoursWrapper = $(document.createElement('ul')).addClass('hours-modal__hours-list');

            // Calculate distance 
            var locationA = {
                latitude: hospitals[a].Latitude,
                longitude: hospitals[a].Longitude
            };
            var locationB = {
                latitude: ui.$currentLat,
                longitude: ui.$currentLng
            } //Need to modify this line of code
            var calcMiles = (haversine(locationA, locationB) * 0.000621371).toFixed(1);
            var distanceApart = `${calcMiles}`;

            // Create Google Map Markers 
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(hospitals[a].Latitude, hospitals[a].Longitude),
                map: ui.$map,
                animation: google.maps.Animation.DROP
            });

            ui.$markers.push(marker);

            var label = new google.maps.InfoWindow({
                content: hospitals[a].Name,
                maxWidth: 200
            });

            google.maps.event.addListener(marker, 'click', (function (marker, infowindow) {
                return function () {
                    infowindow.open(ui.$map, marker);
                };
            })(marker, label));
            bounds.extend(marker.getPosition());

            // Create hospital type tags (left section)
            if (hospitalTypesTags !== null) {
                for (var b = 0; b < hospitalTypesTags.length; b++) {
                    typeTagsWrapper.append(`<li class='search-item__tag'>${hospitalTypesTags[b].DisplayName}</li>`);
                }
            }
            leftContainer.append(typeTagsWrapper);

            // Create right section content
            var hospitalName = $(`<a class="search-item__title" href="${hospitals[a].Url}">${hospitals[a].Name}</a>`);
            var descContainerEl = $(`
                <div class="search-item__details"><span>${hospitals[a].AddressLine1} ${hospitals[a].AddressLine2}</span><span>${hospitals[a].City}, ${hospitals[a].State} ${hospitals[a].Zipcode}</span></div>
                <div class="search-item__side">
                    <span class="search-item__distance-away">${distanceApart} ${hospitals[a].DistanceUnit}</span>
                    <span class="search-item__status ${hospitals[a].IsOpen == true ? `open` : `closed`}">${hospitals[a].IsOpen == true ? `${hospitals[a].OpenLabel}`: `${hospitals[a].CloseLabel}`}</span>
                </div>
            `);

            var ctaContainerEl = $(`
                <div class="search-item__cta-tags">
                    <div class="cta-row">
                        ${hospitals[a].PhoneNumber.length > 0 ? `<a class="cta-tag" href="tel:${hospitals[a].PhoneNumber}">${hospitals[a].PhoneNumber}</a>` : ``}
                        <div class="cta-tag hours-modal-btn">${hospitals[a].HoursLabel}</div>
                    </div>
                    <div class="cta-row">
                        <a class="cta-tag ${hospitals[a].HasCareClub == true && hospitals[a].CareClubUrl !== null ? '' : 'hidden'}" href="${hospitals[a].CareClubUrl}">${hospitals[a].CareClubLabel}</a>
                        <a class="cta-tag ${hospitals[a].HasNewClientOffer == true && hospitals[a].NewClientOfferUrl !== null ? '' : 'hidden'}" href="${hospitals[a].NewClientOfferUrl}">${hospitals[a].NewClientOfferLabel}</a>
                    </div>
                    <div class="cta-row">
                        <a class="btn book-appointment ${hospitals[a].HasBookAnAppointment == true && hospitals[a].BookAnAppointmentUrl !== null ? '' : 'hidden'}" href="${hospitals[a].BookAnAppointmentUrl}">${hospitals[a].BookAnAppointmentLabel}</a>
                        <a class="redirect-to-map ${hospitals[a].DirectionUrl == null || hospitals[a].DirectionUrl == '' ? 'hidden' : ''}" href="${hospitals[a].DirectionUrl}" target="_blank">
                            <img src="${hospitals[a].DirectionImageUrl}" alt="Direction Image">
                        </a>
                    </div>
                </div>  
            `);

            rightContainer.append(hospitalName);
            descContainer.append(descContainerEl);
            ctaContainer.append(ctaContainerEl);
            rightContainer.append(descContainer, ctaContainer);


            // Create Modal
            var modalBtnAndTitle = $(`
                <button type="button" class="hours-modal__close-btn close-btn" aria-label="close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="hours-modal__header">HOURS</div>
            `);

            var bottomModalSection = $(`
                <div class="hours-modal__divider"></div>
                <p class="hours-modal__message ${hospitals[a].HoursDisclaimer == null || hospitals[a].HoursDisclaimer == '' ? 'hidden' : ''}">${hospitals[a].HoursDisclaimer}</p>
                <a class="hours-modal__link" href="${hospitals[a].HoursPageUrl}">View hospital info »</a>
            `);

            var currentDate = setCurrentDate();
            if (hoursObj !== null) {
                hoursObj.forEach(function (hourObj) {
                    var day = hourObj.Item1;
                    var time = hourObj.Item2;
                    var isCurrentDay = hourObj.Item3;
                    var isTemporaryHours = hourObj.Item4;

                    modalHoursWrapper.append(`
                        <li class="${isCurrentDay ? 'active' : ''}">
                            <span class="day">${day}</span>
                            <div class="time"><span>${time}</span><span class="${isTemporaryHours ? '' : 'hidden'}">*</span></div>
                        </li>
                    `);
                });
            }

            modalContainer.append(modalContentWrapper);
            modalContentWrapper.append(modalBtnAndTitle, modalHoursWrapper, bottomModalSection);
            parentContainer.append(leftContainer, rightContainer, modalContainer);
            ui.$resultsContainer.append(parentContainer);

            //Bind events after dynamic content has been created
            ui.$modalBtn = $('.hours-modal-btn');
            ui.$closeBtn = $('.close-btn');
            ui.$modalBtn.on('click', openModal);
            ui.$closeBtn.on('click', closeModal);

            ui.$map.fitBounds(bounds);
        }

        if (hospitals.length === 1) {
            ui.$map.setZoom(15);
        }

        if (hospitals.length === 0) {
            setDefaultMarker();
        }

    }

    function getBounds(lat, lng, radius) {
        let ConvertedRadius = radius * 1609.34;

        // add to canada site
        if (ui.isCanada === 'true') {
            ConvertedRadius = radius * 1000;
        }

        var circleData = {
            center: {
                lat,
                lng
            },
            radius: ConvertedRadius
        };

        if (window['google']) {
            return new window['google'].maps.Circle(circleData).getBounds();
        }
    }

    function getFAHSearchParams() {
        var address = '';
        if ($(ui.$searchValue).val() !== undefined || $(ui.$searchValue).val() !== null || $(ui.$searchValue).val() !== '') {
            address = $(ui.$searchValue).val();
        }
        if (address == '') {
            if (_urlParams.hasSearchText) {
                address = _urlParams.searchText;
            } else if (_urlParams.hasZipCode) {
                address = _urlParams.zipCode;
            }
        }

        var hospitalType;
        if (ui.$selectedFiltersArr.includes('A')) {
            hospitalType = _urlParams.hasHospitalType ? _urlParams.hospitalType : ui.$defaultFilter;
        } else {
            hospitalType = ui.$selectedFiltersArr;
        }

        let radiusValue = _urlParams.hasRadius ? _urlParams.radius : (ui.$defaultRadius == $(ui.$searchRadius).val() ? ui.$defaultRadius : $(ui.$searchRadius).val());
        ui.$bounds = getBounds(ui.$currentLat, ui.$currentLng, radiusValue);
        let minMaxValues = calcMinMaxLatLng(ui.$bounds);
        let fahSearchParams = {
            CurrentLat: ui.$currentLat,
            CurrentLng: ui.$currentLng,
            MinLatitude: minMaxValues.minLat,
            MaxLatitude: minMaxValues.maxLat,
            MinLongitude: minMaxValues.minLng,
            MaxLongitude: minMaxValues.maxLng,
            Radius: radiusValue,
            SearchText: address,
            HospitalType: hospitalType,
            HospitalTypeDisplayName: _urlParams.hasHospitalTypeDisplayName ? unescape(_urlParams.hospitalTypeDisplayName) : null,
            Country: ui.$countryId,
            DataItemId: ui.$dataId
        }

        return fahSearchParams;
    }

    function getSearchResults(errorMessage, blResetFilters) {
        ui.$resultsContainer.empty();
        ui.$resultsContainer.addClass('hidden');
        ui.$errorMsgContainer.addClass('hidden');
        ui.$loadingSpinner.removeClass('hidden');
        let fahSearchParams = getFAHSearchParams();
        ui.$bounds = getBounds(fahSearchParams.CurrentLat, fahSearchParams.CurrentLng, fahSearchParams.Radius);

        axios.post('/fah-api/search-hospital', fahSearchParams)
            .then(response => {
                if (response.data.OK) {
                    if (blResetFilters) {
                        let activeFilter = $('.filter-pills__wrapper').find('.filter-pills__pill.active');
                        let primaryFilter = $('.filter-pills__wrapper').find('.filter-pills__pill')[0];
                        $(activeFilter).removeClass('active');
                        $(primaryFilter).addClass('active');
                    }
                    let data = response.data.result;
                    let sortedData = sortResults(data);
                    removeMarkers();
                    createCard(sortedData);
                    ui.$loadingSpinner.addClass('hidden');
                    ui.$resultsContainer.removeClass('hidden');
                    if (response.data.result.length === 0) {
                        showErrorMessage("No Results.");
                    }
                } else {
                    removeMarkers();
                    ui.$loadingSpinner.addClass('hidden');
                    showErrorMessage(response.data.error);
                }
            })
            .catch(error => {
                ui.$loadingSpinner.addClass('hidden');
                ui.$errorMsgContainer.removeClass('hidden');
                console.log(errorMessage, error.response);
            });
    }

    function handleLocationError(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
            browserHasGeolocation ?
            "Error: The Geolocation service failed." :
            "Error: Your browser doesn't support geolocation."
        );
        infoWindow.open(ui.$map);
        ui.$loadingSpinner.addClass('hidden');
        if (ui.isCanada) {
            showErrorMessage('Please provide address or postal code.');
        } else {
            showErrorMessage('Please provide address or zipcode.');
        }
    }

    function hasSearchParams() {
        return _urlParams.hasHospitalType || _urlParams.hasRadius || _urlParams.hasZipCode || _urlParams.hasSearchText || _urlParams.hasHospitalTypeDisplayName;
    }

    function initDefaultSelectedFilter() {
        //include default selected filter on page load to ui.$selectedFiltersArr
        let defaultFilter = $('.filter-pills').find('.slick-slide')[0];
        let defaultFilterValue = $(defaultFilter).find('.filter-pills__pill.active').data('filter-value');
        ui.$selectedFiltersArr.push(defaultFilterValue);
    }

    function initPage() {
        if ($('#FindAHospitalMap').length <= 0) {
            return;
        }

        setCurrentDate();
        setSearchDefaultRadius();

        ui.$geocoder = new google.maps.Geocoder();
        ui.$map = new google.maps.Map(document.getElementById('FindAHospitalMap'), {
            center: new google.maps.LatLng(ui.$defaultLatitude, ui.$defaultLongitude),
            zoom: 12 //1 (furthest) to 20 (closest)
        });

        var infoWindow = new google.maps.InfoWindow();

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    ui.$currentLat = position.coords.latitude;
                    ui.$currentLng = position.coords.longitude;
                    ui.$map.setCenter(pos);
                    // If coming from the home page search field,
                    // getHospitalsData() will return before getSearchResults() does
                    // and will show a "No results" message before valid results are shown.
                    if (window.location.search.length === 0) {
                        getSearchResults('Error: ', false);
                    } else {
                        queryOnInitValidation();
                    }
                },
                () => {
                    handleLocationError(true, infoWindow, ui.$map.getCenter());
                }
            );
        } else {
            // Browser doesn't support Geolocation
            handleLocationError(false, infoWindow, ui.$map.getCenter());
        }
    }

    function initParams() {
        let urlParams = new URL(window.location);
        _urlParams.hasHospitalType = urlParams.searchParams.has('f');
        _urlParams.hospitalType = urlParams.searchParams.get('f');
        if (_urlParams.hasHospitalType) {
            if (_urlParams.hospitalType == undefined || _urlParams.hospitalType == null || _urlParams.hospitalType == '') {
                _urlParams.hasHospitalType = false;
            }
        }

        _urlParams.hasRadius = urlParams.searchParams.has('r');
        _urlParams.radius = urlParams.searchParams.get('r');
        if (_urlParams.hasRadius) {
            if (_urlParams.radius == undefined || _urlParams.radius == null || _urlParams.radius == '') {
                _urlParams.hasRadius = false;
            }
        }

        _urlParams.hasSearchText = urlParams.searchParams.has('text');
        _urlParams.searchText = urlParams.searchParams.get('text');
        if (_urlParams.hasSearchText) {
            if (_urlParams.searchText == undefined || _urlParams.searchText == null || _urlParams.searchText == '') {
                _urlParams.hasSearchText = false;
            }
        }

        _urlParams.hasHospitalTypeDisplayName = urlParams.searchParams.has('type');
        _urlParams.hospitalTypeDisplayName = urlParams.searchParams.get('type');
        if (_urlParams.hasHospitalTypeDisplayName) {
            if (_urlParams.hospitalTypeDisplayName == undefined || _urlParams.hospitalTypeDisplayName == null || _urlParams.hospitalTypeDisplayName == '') {
                _urlParams.hasHospitalTypeDisplayName = false;
            }
        }

        _urlParams.hasZipCode = urlParams.searchParams.has('t');
        _urlParams.zipCode = urlParams.searchParams.get('t');
        if (_urlParams.hasZipCode) {
            if (_urlParams.zipCode == undefined || _urlParams.zipCode == null || _urlParams.zipCode == '') {
                _urlParams.hasZipCode = false;
            }
        }
    }

    function openModal(e) {
        e.stopPropagation();
        var parentContainer = e.target.closest('.search-item');
        var modal = $(parentContainer).find('.hours-modal');
        $(modal).css('display', 'block');
    }

    function queryOnInitValidation() {
        if (hasSearchParams()) {
            if (_urlParams.hasRadius) {
                $('.js-vca-dropdown-button')[0].innerText = _urlParams.radius + " miles";
            }
            if (_urlParams.hasHospitalType || _urlParams.hasHospitalTypeDisplayName) {
                selectFilterOnLoad();
            }
            if (_urlParams.hasSearchText) {
                $(ui.$searchValue).val(_urlParams.searchText);
                $(ui.$searchValue).text(_urlParams.searchText);
                selectSearch();
            } else if (_urlParams.hasZipCode) {
                $(ui.$searchValue).val(_urlParams.zipCode);
                $(ui.$searchValue).text(_urlParams.zipCode);
                selectSearch();
            } else {
                getSearchResults('Error: ', false);
            }
        } else {
            setDefaultMarker();
            return;
        }
    }

    function removeMarkers() {
        for (let i = 0; i < ui.$markers.length; i++) {
            ui.$markers[i].setMap(null);
        }
    }

    function selectFilter(e) {
        if (e !== undefined) {
            e.preventDefault();
        }

        var selectedFilter = $(e.target).data('filter-value');

        // Disable the default filter, if another filter has been selected
        if ($(e.target).attr('id') === undefined || $(e.target).attr('id') !== 'defaultFilter') {
            $('#defaultFilter').removeClass('active');

            // Make sure the default filter value is not in the ui.$selectedFiltersArr
            var indexOfDefaultFilter = ui.$selectedFiltersArr.indexOf($('#defaultFilter').data('filter-value'));
            if (indexOfDefaultFilter > -1) {
                ui.$selectedFiltersArr.splice(indexOfDefaultFilter, 1);
            }
        } else {
            // If the default filter has been selected, clear all other filter pills
            ui.$selectedFiltersArr.length = 0;
            $('.filter-pills__pill').each(function (index, item) {
                item.classList.remove('active');
                ui.$selectedFiltersArr.splice(indexOfDefaultFilter, 1);
            });
        }

        //Check if selected filter exists in ui.$selectedFiltersArr
        if (ui.$selectedFiltersArr.includes(selectedFilter)) {
            ui.$selectedFiltersArr = ui.$selectedFiltersArr.filter(e => e !== selectedFilter);
            $(e.target).removeClass('active');
        } else {
            ui.$selectedFiltersArr.push(selectedFilter);
            $(e.target).addClass('active');
        }

        // If no filters are selected, enable the default filter
        if ($(".filter-pills__pill.active").length === 0) {
            $('#defaultFilter').addClass('active');
            ui.$selectedFiltersArr.push($('#defaultFilter').data('filter-value'));
        }

        if (ui.$currentLat == undefined || ui.$currentLng == undefined) {
            return;
        }

        ui.$resultsContainer.empty();
        ui.$errorMsgContainer.addClass('hidden');
        ui.$loadingSpinner.removeClass('hidden');
        ui.$bounds = getBounds(ui.$currentLat, ui.$currentLng, ui.$defaultRadius);

        getSearchResults('Error on filter pill: ', false);
    }

    function selectFilterOnLoad() {
        if (_urlParams.hasHospitalType) {
            _urlParams.hospitalType.split(',').forEach((selectedType) => {
                let selectedPill = $(`.filter-pills__pill[data-filter-value="${selectedType}" i]`);
                if (selectedPill) {
                    selectPill(selectedPill, selectedType);
                }
            });
        }

        if (_urlParams.hasHospitalTypeDisplayName) {
            _urlParams.hospitalTypeDisplayName.split(',').forEach((selectedType) => {
                var unescapedSelectedType = unescape(selectedType);
                let selectedPill = $(`.filter-pills__pill[data-filter-display-name="${unescapedSelectedType}" i]`);
                if (selectedPill) {
                    // In this case the "selectedType" value is the display name.
                    // We need the data-filter-value value instead.
                    selectPill(selectedPill, selectedPill.attr("data-filter-value"));
                }
            });
        }

        if (ui.$currentLat == undefined || ui.$currentLng == undefined) {
            return;
        }

        ui.$resultsContainer.empty();
        ui.$errorMsgContainer.addClass('hidden');
        ui.$loadingSpinner.removeClass('hidden');
        ui.$bounds = getBounds(ui.$currentLat, ui.$currentLng, ui.$defaultRadius);

        getSearchResults('Error on filter pill: ', false);
    }

    function selectPill(selectedPill, selectedType) {
        $('#defaultFilter').removeClass('active');

        // Make sure the default filter value is not in the ui.$selectedFiltersArr
        var indexOfDefaultFilter = ui.$selectedFiltersArr.indexOf($('#defaultFilter').data('filter-value'));
        if (indexOfDefaultFilter > -1) {
            ui.$selectedFiltersArr.splice(indexOfDefaultFilter, 1);
        }

        ui.$selectedFiltersArr.push(selectedType);
        selectedPill.addClass('active');
    }

    function selectSearch(e) {
        if (e !== undefined) {
            e.preventDefault();
        }
        let address = $(ui.$searchValue).val();

        // Check for when no current location and address have been provided
        if (address == '' && ui.$currentLat == undefined && ui.$currentLng == undefined) {
            return;
        }

        if (address !== ui.$prevSearchValue && address !== '') {
            ui.$currentLat = undefined;
            ui.$currentLng = undefined;
        }
        ui.$prevSearchValue = address;

        // Check for when address is not provided but current location and selected radius are
        if (address == '' && ui.$currentLat && ui.$currentLng) {
            getSearchResults('Error on search button: ', !(_urlParams.hasHospitalType || _urlParams.hasHospitalTypeDisplayName));

            // Check for when address is provided but current location is not 
        } else if (address !== '' && ui.$currentLat == undefined && ui.$currentLng == undefined) {
            let countryAddress = address;
            if (ui.isCanada === 'true') {
                countryAddress = address + ', Canada';
            } else {
                countryAddress = address + ', USA';
            }
            ui.$geocoder.geocode({
                'address': countryAddress
            }, function (results, status) {
                if (status == 'OK') {
                    ui.$currentLat = results[0].geometry.location.lat();
                    ui.$currentLng = results[0].geometry.location.lng();
                    getSearchResults('Error on search button: ', !(_urlParams.hasHospitalType || _urlParams.hasHospitalTypeDisplayName));
                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            });

            // Check for when both address current location have been provided
        } else if (address !== '' && ui.$currentLat && ui.$currentLng) {
            getSearchResults('Error on search button: ', !(_urlParams.hasHospitalType || _urlParams.hasHospitalTypeDisplayName));
        }
    }

    function setCurrentDate() {
        var dotw = '';
        switch (new Date().getDay()) {
            case 0:
                dotw = "Sun";
                break;
            case 1:
                dotw = "Mon";
                break;
            case 2:
                dotw = "Tues";
                break;
            case 3:
                dotw = "Wed";
                break;
            case 4:
                dotw = "Thurs";
                break;
            case 5:
                dotw = "Fri";
                break;
            case 6:
                dotw = "Sat";
        }

        return dotw;
    }

    function setDefaultMarker() {
        var currentLatLng = new google.maps.LatLng(ui.$defaultLatitude, ui.$defaultLongitude);
        var marker = new google.maps.Marker({
            position: currentLatLng,
            map: ui.$map,
            animation: google.maps.Animation.DROP,
            zoom: 8,
            center: currentLatLng
        });
    }

    function setSearchDefaultRadius() {
        ui.$searchRadius.val(ui.$defaultRadius);
        if (ui.isCanada === 'true') {
            $('.find-search__dropdown-btn').text(`${ui.$defaultRadius} KM`);
        } else {
            $('.find-search__dropdown-btn').text(`${ui.$defaultRadius} miles`);
        }
        var radiusOnLoad = $('.find-search__dropdown-list').find(`[data-value="${ui.$defaultRadius}"]`)[0];
        $(radiusOnLoad).addClass('focused selected');
    }

    function showErrorMessage(errorMessage) {
        ui.$errorMessage.text(errorMessage);
        ui.$errorMsgContainer.removeClass('hidden');
        console.log(errorMessage, error.response);
    }

    function sortResults(data) {
        var results = [...data];
        $(results).each(function () {
            var hospLat = this.Latitude;
            var hospLng = this.Longitude;
            var setA = {
                latitude: hospLat,
                longitude: hospLng
            };
            var setB = {
                latitude: ui.$currentLat,
                longitude: ui.$currentLng
            }
            var miles = (haversine(setA, setB) * 0.000621371).toFixed(1);
            this.miles = Number(miles);
        });
        var sortedArray = results.sort(function (a, b) {
            return a.miles - b.miles
        });
        return sortedArray;
    }

    function init() {
        cacheUI();
        bindEvents();
        initParams();
        initDefaultSelectedFilter();
        initPage();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {

    if ($('#FindAHospitalMap').length <= 0) {
        return;
    }
    //check for hiding left arrow in filter pills carousel
    let primaryFilter = $('.filter-pills').find('.slick-slide')[0];
    let leftArrowBtn = $('.filter-pills').find('.slick-prev.slick-arrow');
    let primaryIsSelected = $(primaryFilter).hasClass('slick-active');
    if (primaryIsSelected) {
        $(leftArrowBtn).hide();
    }

    $('.slick-prev').on('click', function (event) {
        event.preventDefault();
        primaryFilter = $('.filter-pills').find('.slick-slide')[0];
        primaryIsSelected = $(primaryFilter).hasClass('slick-active');

        if (primaryIsSelected) {
            $(leftArrowBtn).hide();
        }
    });

    $('.slick-next').on('click', function (event) {
        event.preventDefault();
        $(leftArrowBtn).show();
    });

    const mapEl = document.getElementById('FindAHospitalMap');

    function checkForGoogleMaps() {
        setTimeout(() => {
            if('google' in window && typeof google === 'object' && typeof google.maps === 'object' && mapEl){
                console.log('google', google);
                VCA.FindAHospital.init(mapEl);
            }
            else {
                checkForGoogleMaps();
            }
        }, 1000);
    }

    checkForGoogleMaps();
});